export default "__VITE_ASSET__ChYme_rl__"